import { createColumnHelper } from "@tanstack/react-table";
import { ResellersListItem } from "modules/resellers";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PersonInfo } from "ui";

import styles from "../styles/TableStyles.module.scss";

const columnHelper = createColumnHelper<ResellersListItem>();

const useResellersColumns = () => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      columnHelper.accessor((row) => row.id, {
        id: "id",
        header: "#",
        enableSorting: false,
        size: 0.5,
        minSize: 0.5,
        cell: (cell) => (
          <p className={styles["statistics__table--index"]}>
            {cell.row.index + 1}
          </p>
        )
      }),
      columnHelper.accessor((row) => row.firstname, {
        id: "name",
        header: t("Reseller"),
        enableSorting: false,
        size: 10,
        minSize: 10,
        cell: (cell) => (
          <PersonInfo
            image={cell.row.original.image}
            personName={`${cell.getValue()} ${cell.row.original.lastname}`}
            nameClassName={styles["statistics__table--name"]}
          />
        )
      }),
      columnHelper.accessor((row) => row.totalEarnings, {
        id: "totalEarnings",
        header: t("Earnings"),
        enableSorting: false,
        size: 3,
        minSize: 3,
        cell: (cell) => cell.getValue().toLocaleString("en-US") ?? 0
      }),
      columnHelper.accessor((row) => row.totalSales, {
        id: "totalSales",
        header: t("Total sales"),
        enableSorting: false,
        size: 3,
        minSize: 3,
        cell: (cell) => Math.ceil(cell.getValue()).toLocaleString("en-US") ?? 0
      })
    ],
    [t]
  );

  return { columns };
};

export default useResellersColumns;
